"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enquiryStates = exports.SLUGS = exports.CATEGORIES = void 0;
exports.CATEGORIES = Object.freeze({
    FOR_SALE: 'for_sale',
    JUNK: 'junk',
    PROFILED: 'profiled',
    QUOTED: 'quoted',
    REJECTED: 'rejected',
    SOLD: 'sold',
    UNSOLD: 'unsold',
    CANCELLED: 'cancelled',
});
exports.SLUGS = Object.freeze({
    UNDER_OFFER: 'under_offer',
    MANUAL_QUOTE: 'manual_quote',
    QUOTED: 'quoted',
    FOR_SALE: 'for_sale',
    SOLD: 'sold',
    SOLD_INVOICE_RAISED: 'sold_invoice_raised',
    SOLD_WAIT: 'sold_wait',
    SOLD_CONFIRMED: 'sold_confirmed',
    SOLD_PURCHASE_CONFIRMED: 'sold_purchase_confirmed',
    SOLD_DOCUMENTS_REVIEWED: 'sold_documents_reviewed',
    FULL_DETAILS_WAIT: 'full_details_wait',
    FULL_DETAILS: 'full_details',
    FULL_DETAILS_CONTACTED: 'full_details_contacted',
    QA_READY: 'qa_ready',
    QA_FAILED: 'qa_failed',
    QA_ON_HOLD: 'qa_on_hold',
    PART_DETAILS: 'part_details',
    QUOTE_ACCEPTED: 'quote_accepted',
    QUOTED_SELLER_CONTACTED: 'quoted_seller_contacted',
    SOLD_INVOICE_PAID: 'sold_invoice_paid',
    TEST: 'test',
    WRONG_NUMBER: 'wrong_number',
    CAR_GONE: 'car_gone',
    CUSTOMER_LOST: 'customer_lost',
    UNWORKED: 'unworked',
    DUPLICATED: 'duplicated',
    PART_DETAILS_CONTACTED: 'part_details_contacted',
    UNSELLABLE: 'unsellable',
    TOO_EXPENSIVE: 'too_expensive',
    CUSTOMER_KEEP_CAR: 'customer_keep_car',
    READY_FOR_SALE: 'ready_for_sale',
    WRITE_OFF: 'write_off',
    SALE_ACTIVE: 'sale_active',
    NOT_AS_DESCRIBED: 'cancelled_not_as_described',
    UNCONTACTABLE: 'cancelled_seller_uncontactable',
    SOLD_ELSEWHERE: 'cancelled_sold_elsewhere',
    NOT_COLLECTED_IN_TIME: 'cancelled_not_collected_in_time',
    DEALER_WITHDREW_BID: 'cancelled_dealer_withdrew_bid',
    OTHER_SELLER_ISSUES: 'cancelled_other_seller_issue',
    OTHER_DEALER_ISSUES: 'cancelled_other_dealer_issue',
    UNDER_REVIEW: 'cancelled_under_review',
    UNSOLD_NO_BIDS: 'unsold_no_bids',
    UNSOLD_BELOW_RESERVE_BID: 'unsold_below_reserve_bid',
    HPI_QUERY: 'hpi_query',
});
exports.enquiryStates = Object.freeze({
    [exports.SLUGS.UNDER_OFFER]: {
        category: exports.CATEGORIES.FOR_SALE,
        name: 'Under offer',
    },
    [exports.SLUGS.MANUAL_QUOTE]: {
        category: exports.CATEGORIES.QUOTED,
        name: 'Manual quote',
    },
    [exports.SLUGS.QUOTED]: {
        category: exports.CATEGORIES.QUOTED,
        name: 'Quoted',
    },
    [exports.SLUGS.FOR_SALE]: {
        category: exports.CATEGORIES.FOR_SALE,
        name: 'For sale',
    },
    [exports.SLUGS.SOLD_WAIT]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Awaiting confirmation',
    },
    [exports.SLUGS.SOLD]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold',
    },
    [exports.SLUGS.SOLD_INVOICE_RAISED]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Invoice raised',
    },
    [exports.SLUGS.SOLD_CONFIRMED]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Seller confirmed',
    },
    [exports.SLUGS.SOLD_PURCHASE_CONFIRMED]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Purchase confirmed',
    },
    [exports.SLUGS.SOLD_DOCUMENTS_REVIEWED]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Documents reviewed',
    },
    [exports.SLUGS.FULL_DETAILS_WAIT]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'Full details - Agent profiling',
        profilingStatuses: {
            photos_requested: 'Photos requested',
            service_history: 'Service history',
            pop_requested: 'POP requested',
            finance: 'Finance',
            prep_query: 'Prep query',
            confirming_reserve_with_seller: 'Confirming reserve with seller',
            other: 'Other',
        },
    },
    [exports.SLUGS.FULL_DETAILS]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'Full details',
    },
    [exports.SLUGS.FULL_DETAILS_CONTACTED]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'Full details - Seller contacted',
    },
    [exports.SLUGS.QA_READY]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'QA - Ready',
    },
    [exports.SLUGS.QA_ON_HOLD]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'QA - On hold',
    },
    [exports.SLUGS.QA_FAILED]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'QA - Failed',
        reasons: [
            {
                name: 'Prep',
                options: [
                    {
                        id: 'prep_calculation_incorrect',
                        name: 'Prep calculation incorrect',
                    },
                    {
                        id: 'misidentified_prep',
                        name: 'Misidentified prep',
                    },
                ],
            },
            {
                name: 'Damage',
                options: [
                    {
                        id: 'damage_misidentified',
                        name: 'Damage misidentified',
                    },
                    {
                        id: 'damage_missed',
                        name: 'Damage missed',
                    },
                ],
            },
            {
                name: 'Images',
                options: [
                    {
                        id: 'missing_image',
                        name: 'Missing image',
                    },
                    {
                        id: 'unclear_image',
                        name: 'Unclear image',
                    },
                    {
                        id: 'poorly_framed',
                        name: 'Poorly framed',
                    },
                    {
                        id: 'duplicate_image',
                        name: 'Duplicate image',
                    },
                    {
                        id: 'guidelines_not_followed',
                        name: 'Guidelines not followed',
                    },
                ],
            },
            {
                name: 'Incomplete profile',
                options: [
                    {
                        id: 'incomplete_profile',
                        name: 'Incomplete profile',
                    },
                    {
                        id: 'expired_price',
                        name: 'Expired price',
                    },
                    {
                        id: 'unacceptable_timings',
                        name: 'Unacceptable timings',
                    },
                ],
            },
            {
                name: 'Missing POP',
                options: [
                    {
                        id: 'missing_pop',
                        name: 'Missing POP',
                    },
                ],
            },
            {
                name: 'Service incorrect',
                options: [
                    {
                        id: 'missing_mileage_date_on_docs',
                        name: 'Missing mileage/date on docs',
                    },
                    {
                        id: 'unacceptable_docs',
                        name: 'Unacceptable docs',
                    },
                    {
                        id: 'incomplete_service_info',
                        name: 'Incomplete service info',
                    },
                ],
            },
            {
                name: 'Missing notes',
                options: [
                    {
                        id: 'missing_notes',
                        name: 'Missing notes',
                    },
                ],
            },
        ],
    },
    [exports.SLUGS.PART_DETAILS]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'Part details',
    },
    [exports.SLUGS.QUOTE_ACCEPTED]: {
        category: exports.CATEGORIES.QUOTED,
        name: 'Quote accepted',
    },
    [exports.SLUGS.QUOTED_SELLER_CONTACTED]: {
        category: exports.CATEGORIES.QUOTED,
        name: 'Quoted - Seller contacted',
    },
    [exports.SLUGS.SOLD_INVOICE_PAID]: {
        category: exports.CATEGORIES.SOLD,
        name: 'Sold - Invoice paid',
    },
    [exports.SLUGS.TEST]: {
        category: exports.CATEGORIES.JUNK,
        name: 'Test run',
    },
    [exports.SLUGS.WRONG_NUMBER]: {
        category: exports.CATEGORIES.JUNK,
        name: 'Wrong number',
    },
    [exports.SLUGS.CAR_GONE]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Car sold elsewhere',
    },
    [exports.SLUGS.CUSTOMER_LOST]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Lost contact with seller',
    },
    [exports.SLUGS.UNWORKED]: {
        category: exports.CATEGORIES.JUNK,
        name: 'Un-worked',
    },
    [exports.SLUGS.DUPLICATED]: {
        category: exports.CATEGORIES.JUNK,
        name: 'Duplicate lead',
    },
    [exports.SLUGS.PART_DETAILS_CONTACTED]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'Part details - Seller contacted',
    },
    [exports.SLUGS.UNSELLABLE]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Unsellable',
    },
    [exports.SLUGS.TOO_EXPENSIVE]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Price too high',
    },
    [exports.SLUGS.CUSTOMER_KEEP_CAR]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Seller keeping car',
    },
    [exports.SLUGS.READY_FOR_SALE]: {
        category: exports.CATEGORIES.FOR_SALE,
        name: 'Ready for sale',
    },
    [exports.SLUGS.WRITE_OFF]: {
        category: exports.CATEGORIES.REJECTED,
        name: 'Rejected - Write-off',
    },
    [exports.SLUGS.SALE_ACTIVE]: {
        category: exports.CATEGORIES.FOR_SALE,
        name: 'For sale - Sale active',
    },
    [exports.SLUGS.NOT_AS_DESCRIBED]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Not as described',
    },
    [exports.SLUGS.UNCONTACTABLE]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Seller uncontactable',
    },
    [exports.SLUGS.SOLD_ELSEWHERE]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Sold elsewhere',
    },
    [exports.SLUGS.NOT_COLLECTED_IN_TIME]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Not collected in time',
    },
    [exports.SLUGS.DEALER_WITHDREW_BID]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Dealer withdrew bid',
    },
    [exports.SLUGS.OTHER_SELLER_ISSUES]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Other seller issue',
    },
    [exports.SLUGS.OTHER_DEALER_ISSUES]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Other dealer issue',
    },
    [exports.SLUGS.UNDER_REVIEW]: {
        category: exports.CATEGORIES.CANCELLED,
        name: 'Cancelled - Under review',
    },
    [exports.SLUGS.UNSOLD_NO_BIDS]: {
        category: exports.CATEGORIES.UNSOLD,
        name: 'Unsold - No bids',
    },
    [exports.SLUGS.UNSOLD_BELOW_RESERVE_BID]: {
        category: exports.CATEGORIES.UNSOLD,
        name: 'Unsold - Below reserve bid',
    },
    [exports.SLUGS.HPI_QUERY]: {
        category: exports.CATEGORIES.PROFILED,
        name: 'HPI query',
    },
});
//# sourceMappingURL=enquiryStates.js.map